<div class="align-right">
  <button mat-button color="primary" (click)="addQuestionCategory()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="questionCategories" matSort>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.dialogs.description" |translate}}</th>
      <td mat-cell *matCellDef="let qc">{{qc.description}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let qc">
        <mat-icon (click)="editQuestionCategory(qc)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
